import { render, staticRenderFns } from "./HorarioBatidaCard.vue?vue&type=template&id=0b8a7c17&scoped=true"
import script from "./HorarioBatidaCard.vue?vue&type=script&lang=js"
export * from "./HorarioBatidaCard.vue?vue&type=script&lang=js"
import style0 from "./HorarioBatidaCard.vue?vue&type=style&index=0&id=0b8a7c17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a7c17",
  null
  
)

export default component.exports